module.exports = __webpack_public_path__ + "default-9cdca736f114c54b34fe.svg";